import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function BasicTab() {
  const [value, setValue] = React.useState(0);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Quota Modification Approval"
            sx={{ textTransform: "none" }}
            component={Link}
            to="quota-modification"
            value={"/approval/quota-modification"}
          />
          <Tab
            label="Quota Approval"
            sx={{ textTransform: "none" }}
            component={Link}
            to="quota"
            value={"/approval/quota"}
          />
          <Tab
            label="Scenario Approval"
            sx={{ textTransform: "none" }}
            component={Link}
            to="scenario"
            value={"/approval/scenario"}
          />
          <Tab
						  label="Product/Customer Group Approval"
						  sx={{ textTransform: "none" }}
              component={Link}
              to="customer-product"
              value={"/approval/customer-product"}
					/> 
        </Tabs>
      </Box>
    </Box>
  );
}
